import React, { memo } from 'react'
import styles from './styles.module.scss'

interface PartnerFullNameInputProps {
  fullName: string
  partnerFullName: string
  error: string
  onFullNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onPartnerFullNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

/* eslint-disable react/prop-types */
const PartnerFullNameInput = memo<PartnerFullNameInputProps>(
  ({ fullName, partnerFullName, error, onFullNameChange, onPartnerFullNameChange, onKeyDown }) => {
    return (
      <div className={styles.partnerFullNameInputContainer + (error ? ' ' + styles.hasError : '')}>
        <input
          className={styles.partnerFullNameInput}
          placeholder="Your full name"
          value={fullName}
          onChange={onFullNameChange}
          onKeyDown={onKeyDown}
          type="text"
          aria-label="Your full name"
          aria-invalid={!!error}
        />
        <input
          className={styles.partnerFullNameInput}
          placeholder="Your partner's full name"
          value={partnerFullName}
          onChange={onPartnerFullNameChange}
          onKeyDown={onKeyDown}
          type="text"
          aria-label="Your partner's full name"
          aria-invalid={!!error}
        />
        {error && (
          <div className={styles.errorMessage} role="alert" aria-live="polite">
            {error}
          </div>
        )}
      </div>
    )
  }
)

PartnerFullNameInput.displayName = 'PartnerFullNameInput'

export default PartnerFullNameInput
